import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Services.css";
import Card from "react-bootstrap/Card";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import serviceData from './Services.json';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloud, faShieldHalved, faUserSecret, faBuilding, faPersonChalkboard, faUsers } from "@fortawesome/free-solid-svg-icons";

function Services() {
  const [service] = useState(serviceData);

  const iconMap = {
    faCloud,
    faShieldHalved,
    faUserSecret,
    faBuilding,
    faPersonChalkboard,
    faUsers
  };

  return (
    <div>
      <section
        className="d-flex flex-column align-items-center justify-content-center" // Add my-4 for vertical margin
        style={{ background: "#252e44" }}
      >
      {/* TITLE */}
        <div className="d-flex justify-content-center align-items-center text-light mt-5">
          <h1 className="fw-bold">
            OUR <span style={{ color: "#92c8ff" }}>SERVICES</span>
          </h1>
        </div>
        {/* CARDS */}
        <Row
          className="service-cardRow g-5"
        >
          {service.map((service, i) => (
            <Col
              key={i}
              xs={12} // cards per row on extra small screens
              md={6} // cards per row on medium screens
              lg={4} // cards per row on large screens
              className="d-flex justify-content-center"
            >
              <Card
                className="service-card border-light text-light d-flex flex-column"
              >
                <Card.Body className="d-flex flex-column justify-content-start align-items-center">
                  <FontAwesomeIcon icon={iconMap[service.imgicon]} alt="Services" size="4x" className="my-3" />
                  <h5 className="information-title text-light mb-2">{service.title}</h5>
                  <p className="information-p text-light text-justify">
                    {service.info}
                  </p>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </section>
    </div>
  );
}

export default Services;
